<template>
    <div class="case-footer">
        <div class="container">
            <div class="heading-text" v-html="headingtext"></div>
            <div class="content">
                <div class="row no-margin flex-horizontal-align-center">
                    <div
                        :key="index"
                        v-for="(element, index) in elements"
                        class="row-element col-l-3 col-m-3 col-s-12"
                    >
                        <div class="box">
                            <div class="top">
                                <div v-if="!element.top_image" class="text">{{element.top_text}}</div>
                                <div v-if="element.top_image" class="image">
                                    <img :src="element.top_image.url" alt />
                                </div>
                            </div>
                            <div class="bottom" v-html="element.text"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "case-footer",
    data() {
        return {
            headingtext: this.blockdata.heading_text,
            elements: this.blockdata.elements
        };
    }
};
</script>


// WEBPACK FOOTER //
// CaseFooter.vue?a6eaeee2